// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lokix: PokeData = {
  "id": 920,
  "name": "lokix",
  "height": 10,
  "weight": 175,
  "base_experience": 158,
  "types": [
    PokeType.BUG,
    PokeType.DARK
  ],
  "api_moves": [
    "double-kick",
    "tackle",
    "leer",
    "low-kick",
    "agility",
    "screech",
    "detect",
    "endure",
    "astonish",
    "bounce",
    "feint",
    "assurance",
    "sucker-punch",
    "bug-bite",
    "struggle-bug",
    "first-impression",
    "throat-chop",
    "lunge",
    "axe-kick"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "leer",
    "bug-bite",
    "lunge",
    "pursuit",
    "leech-steal",
    "string-shot",
    "pin-missile",
    "snarl",
    "signal-spam",
    "snatch",
    "night-slash"
  ],
  "evolution_chain": {
    "id": 483,
    "item": null,
    "species": [
      {
        "name": "nymble",
        "order": 920,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lokix",
        "order": 921,
        "types": [
          PokeType.BUG,
          PokeType.DARK
        ],
        "evolves_from_species_id": 919,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 105,
    "speed": 140,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
